module.exports = __webpack_public_path__ + "static/assets/4922fce6432890cc4491e735e497e9ef.svg";